import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon64: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M12.315 20c1.067 0 1.951-.793 2.029-1.81l.006-.146.003-5.421h2.942c1.647 0 2.907-1.4 2.678-2.953l-.029-.161-1.589-7.423C18.107.931 17.087.094 15.881.019l-.173-.005L12.78.013c-1.636 0-3.208.327-4.662.871A13.88 13.88 0 0 0 7 1.359V.5a.5.5 0 0 0-.5-.5H2.729A2.728 2.728 0 0 0 0 2.727v10.265a.5.5 0 0 0 .5.499h6a.5.5 0 0 0 .5-.499v-.781l.848.65.307.242.282.229.227.197c.964.881 1.537 1.78 1.609 2.724l.007.203v1.587c0 1.037.836 1.877 1.884 1.952l.151.005ZM6 12.492H1V2.727C1 1.773 1.774.999 2.729.999H6v11.493Zm6.315 6.509c-.536 0-.969-.375-1.028-.847l-.008-.103.001-1.595c0-1.357-.721-2.55-1.941-3.665l-.308-.265-.369-.298-1.03-.786a1.9 1.9 0 0 1-.603-1.379A.489.489 0 0 0 7 9.896l-.001-7.415.205-.107c.369-.188.793-.377 1.265-.554a12.461 12.461 0 0 1 3.861-.799l.45-.009 2.927.001c.766.001 1.424.475 1.634 1.145l.036.137 1.589 7.423c.2.936-.521 1.825-1.532 1.9l-.139.005h-3.442a.5.5 0 0 0-.492.41l-.008.09-.003 5.92c0 .523-.458.958-1.035.958Z"
      />
    </Svg>
  )
}
